/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './edit-system.scss';

/* eslint-disable import/no-unresolved, import/default */

import editSystemTemplate from './edit-system.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.editSystem', [])
    .directive('agEditSystem', EditSystem)
    .name;

/*@ngInject*/
function EditSystem() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: EditSystemController,
        controllerAs: 'vm',
        templateUrl: editSystemTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function EditSystemController($scope, $timeout, $translate, userService, siteService) {

    let vm = this;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';
    vm.system = null;

    vm.save = save;
    vm.cancel = cancel;

    var defaultTitle = $translate.instant('ag.system.system') + '';

    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            vm.ctx.widgetTitle = defaultTitle;
            loadSystem();
        }
    });

    $scope.$on('editModeChanged', function() {
        vm.isEdit = vm.ctx.isEdit;
    });

    function loadSystem() {
        vm.loading = true;
        vm.origSystem = null;
        vm.system = null;
        siteService.getSystem().then(
            function success(system) {
                vm.origSystem = system;
                vm.system = angular.copy(system);
                vm.loading = false;
                resetFormState();
            }
        );
    }

    function resetFormState() {
        $timeout(function() {
            $scope.theForm.updateValidity();
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
        });
    }

    function cancel() {
        vm.system = angular.copy(vm.origSystem);
        resetFormState();
    }

    function save() {
        if ($scope.theForm.updateValidity()) {
            siteService.saveSystem(vm.system).then(function success(system) {
                vm.origSystem = system;
                vm.system = angular.copy(system);
                $scope.theForm.$setPristine();
                $scope.theForm.$setUntouched();
            });
        }
    }

}

